export default __webpack_public_path__ + "static/media/Close.edbe4dce.svg";